export default {
	channel: 'Kanál',
	state: 'Stav',
	communicationName: 'Název komunikace',
	display: 'Zobrazení',
	byWorkload: 'Dle vyřízenosti',
	bySubstitute: 'Dle náhrady',
	byPPK: 'Dle PPK',
	week: 'Týden',
	reset: 'Vynulovat',
	curveSequence: 'Vyplňte korektní hodnoty pro označené týdny kampaně.',
	startupCurveHeading: 'Detail náběhové křivky',
};
